export default {
    PGP_EXTOLE: "PGP_EXTOLE",
    PGP: "PGP",
    JWT: "JWT",
    SSH: "SSH",
    PASSWORD: "PASSWORD",
    WEBHOOK: "WEBHOOK",
};
